import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormSubmitRoute: InvariantJiraRoute = {
	name: 'classic-business-form-submit',
	path: '/jira/core/projects/:projectKey/form/:formId',
	exact: true,
};
